import React, { useRef, useState } from "react";
import { FiCalendar } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { parseDateOnly } from "../../../utils/dateOnly";
import { useModal } from "../../../context/Modal";
import LoginForm from "../../LoginForm";
import DevotionCalendarPopover from "./DevotionCalendarPopover";

const PAGE_RAISED_SM =
  "shadow-[-4px_-4px_9px_var(--outer-shadow-light),4px_4px_9px_var(--outer-shadow-dark)]";

const CompactDatePicker = ({ date, language = "en" }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.session.user);
  const { setModalContent } = useModal();
  const buttonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const displayedDate = parseDateOnly(date).toLocaleDateString(
    language === "ko" ? "ko-KR" : "en-US",
    { dateStyle: "full" }
  );

  const choose = (selectedDate) => {
    setOpen(false);
    buttonRef.current?.focus();
    navigate(`/devotions/date/${selectedDate}`);
  };

  const iconButton = `inline-flex items-center justify-center w-11 h-11 rounded-full bg-canvas-base text-neu-primary ${PAGE_RAISED_SM} hover:shadow-[-2px_-2px_5px_var(--outer-shadow-light),2px_2px_5px_var(--outer-shadow-dark)] active:shadow-[inset_2px_2px_5px_var(--outer-shadow-dark),inset_-2px_-2px_5px_var(--outer-shadow-light)] transition-all`;

  return (
    <div className="relative flex flex-wrap items-center gap-space-sm">
      <span className="font-noto-serif text-headline-sm text-neu-primary">
        {displayedDate}
      </span>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-label={`Choose devotion date, currently ${displayedDate}`}
        aria-expanded={open}
        aria-haspopup="dialog"
        className={iconButton}
      >
        <FiCalendar aria-hidden="true" className="text-accent-cta" />
      </button>
      {user ? (
        <Link
          to="/my-memos/devotions"
          aria-label="Open My Devotions calendar"
          className={`inline-flex items-center h-11 px-space-md rounded-full bg-canvas-base text-neu-primary text-label-md font-semibold ${PAGE_RAISED_SM} hover:shadow-[-2px_-2px_5px_var(--outer-shadow-light),2px_2px_5px_var(--outer-shadow-dark)] active:shadow-[inset_2px_2px_5px_var(--outer-shadow-dark),inset_-2px_-2px_5px_var(--outer-shadow-light)] transition-all`}
        >
          My Devotions
        </Link>
      ) : (
        <button
          type="button"
          onClick={() => setModalContent(<LoginForm />)}
          aria-label="Sign in to open My Devotions"
          className={`inline-flex items-center h-11 px-space-md rounded-full bg-canvas-base text-neu-primary text-label-md font-semibold ${PAGE_RAISED_SM} hover:shadow-[-2px_-2px_5px_var(--outer-shadow-light),2px_2px_5px_var(--outer-shadow-dark)] active:shadow-[inset_2px_2px_5px_var(--outer-shadow-dark),inset_-2px_-2px_5px_var(--outer-shadow-light)] transition-all`}
        >
          My Devotions
        </button>
      )}
      <DevotionCalendarPopover
        open={open}
        onClose={() => {
          setOpen(false);
          buttonRef.current?.focus();
        }}
        onSelect={choose}
        anchorRef={buttonRef}
        date={date}
        language={language}
      />
    </div>
  );
};

export default CompactDatePicker;
